import React, { useState, useEffect } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Contract, providers, utils } from 'ethers'
import { useDispatch, useSelector } from 'react-redux'
import { setBalanceOfToken } from '../redux/slices/tokenSlice'
import { displayCurrency, displayCurrencyForInput } from '../utils/helpers'
import { useTokenContract } from './useContract' 

export const useToken = () => {
  const {
    account,
    library,
    // chainId,
    // network,
  } = useWeb3React<providers.Web3Provider>()

  const dispatch = useDispatch()

  const contract = useTokenContract()

  const getBalanceOfToken = async (account: string | null | undefined) => {
    const balance = await contract.balanceOf(account)
    dispatch(setBalanceOfToken(displayCurrency(balance, 2)))
  }

  const approve = async (address: string | undefined, value: string) => {
    try {
      const result = await contract.approve(address, utils.parseEther(value))

      const approval = await result.wait()

      if (approval.status === 1 && approval.events[0].event === 'Approval') {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log('error', error)
      throw error
    }
  }

  const allowance = async (
    addressOwner: string | null | undefined,
    address: string | undefined,
  ) => {
    try {
      const result = await contract.allowance(addressOwner, address)
      return result
    } catch (error) {
      console.log('error', error)
    }
  }

  return {
    allowance,
    approve,
    getBalanceOfToken,
  }
}
